/**
 * Endereço das APIs.
 * Sem REACT_APP_FUNCTIONS_BASE, o site segue no caminho que já usa hoje.
 * Com a variável, o build passa a chamar a API publicada na VPS.
 */
export function functionsBase(fallback) {
  const override = process.env.REACT_APP_FUNCTIONS_BASE;
  if (override && String(override).trim()) {
    return String(override).trim().replace(/\/$/, '');
  }
  return fallback;
}
